var render = function () {
  var _vm$form$title, _vm$form;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "FormList",
      "extra-items": [{
        text: (_vm$form$title = (_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : _vm$form.title) !== null && _vm$form$title !== void 0 ? _vm$form$title : '',
        to: 'FormRead',
        params: _vm.$route.params.id
      }, '填寫內容']
    }
  })], 1)]), _c('b-card', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("回答明細 - " + _vm._s(_vm.form.title))]), _c('b-overlay', {
    attrs: {
      "rounded": "sm"
    }
  }, [_c('b-tabs', {
    on: {
      "input": _vm.handleUserChangesTab
    },
    model: {
      value: _vm.activeTabIndex,
      callback: function callback($$v) {
        _vm.activeTabIndex = $$v;
      },
      expression: "activeTabIndex"
    }
  }, [_vm.form.id ? [_vm._l(_vm.tabs, function (tab, index) {
    return [tab.visible ? _c('b-tab', {
      key: index,
      attrs: {
        "title": tab.title
      }
    }, [_c('keep-alive', [_c(tab.component, {
      key: tab.href,
      ref: "child",
      refInFor: true,
      tag: "component",
      attrs: {
        "active": _vm.activeTabIndex === index
      },
      on: {
        "done": _vm.handleTabContentLoaded
      }
    })], 1)], 1) : _vm._e()];
  })] : _vm._e()], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }